import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-add-audit-feesmpr',
  templateUrl: './add-audit-feesmpr.component.html',
  styleUrls: ['./add-audit-feesmpr.component.scss']
})
export class AddAuditFeesmprComponent implements OnInit {
  targetForm!: FormGroup;
  auditFeeForm!: FormGroup;
  submitted = false;
  edit: boolean = false;
  editId: number = 0;
  UserDetails: any;
  blockList: any[] = [];
  financialYears: any[] = [];
  circlesList: any[] = [];
  auditData: any[] = [];
  tableData: any[] = [];
  currentMonth: any = {};
  showButton = false;
  groupedTableData: any[] = []; // For merged table display

  constructor(private fb: FormBuilder,private authService: AuthService, private reportService: ReportsService, private toastService: ToastService) { }

  ngOnInit(): void {
    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],
    });


    this.auditFeeForm = this.fb.group({
      tAuditConductedUptoDate: ['', [Validators.required, Validators.pattern(/^\d+$/)]],

      dAuditFeesAssessed: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      dAuditFeesRecovered: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      dtAuditConducted: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      dAuditFeesBalance: ['', [Validators.required, Validators.pattern(/^\d+$/)]],

      cAuditFeesAssessed: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      cAuditFeesRecovered: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      ctAuditConducted: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      cAuditFeesBalance: ['', [Validators.required, Validators.pattern(/^\d+$/)]],

      caAuditFeesAssessed: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      caAuditFeesRecovered: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      catAuditConducted: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      caAuditFeesBalance: ['', [Validators.required, Validators.pattern(/^\d+$/)]],

      rAuditFeesAssessed: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      rAuditFeesRecovered: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      rtAuditConducted: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      rAuditFeesBalance: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
    });

    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;


    this.GetBlock();
    this.getTargetCount();
    if (this.UserDetails?.roleId == 11) {
      const userBlock = this.UserDetails?.iBlockId;

      this.targetForm.controls['blockOffice'].setValue(userBlock);
      this.targetForm.controls['blockOffice'].disable();


    }
    
      switch (this.UserDetails?.roleId) {
        case 13:

          break;
        case 1:
          this.targetForm.addControl('circleOffice', new FormControl({
            value: '',
            disabled: false
          }, Validators.required));
          this.getCircle();
          break;
        case 11:
          this.targetForm.controls['blockOffice'].disable();
          this.targetForm.get('blockOffice')?.valueChanges
            .pipe(skip(1))
            .subscribe((val: any) => {
              if (this.targetForm.valid) {
                this.getTargetCount();
              }
            });

          break;
        default:
      }


  }


  getCircle() {
    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;
      }
    },
      (error: any) => {
      }
    );
  }


  GetBlock() {
    let obj = {
      "blockId": 0,
      "circleId": this.targetForm.value.circleOffice
    }

    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {
        this.blockList = res.data?.block;
        //this.targetForm.controls['blockOffice'].setValue('');

      }
    },
      (error: any) => {
      }
    );
  }

  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {

        this.financialYears = res.data.financialYears
      }
    },
      (error: any) => {
      }
    );
  }

  isInvalid(controlName: string): boolean {
    const control = this.auditFeeForm.get(controlName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  get f() {
    return this.auditFeeForm.controls;
  }

  onlyNumbers(event: KeyboardEvent) {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }


  onSubmit(): void {
    this.submitted = true;

    if (this.auditFeeForm.invalid) {
      this.auditFeeForm.markAllAsTouched();
      return;
    }

    const formData: any = this.auditFeeForm.getRawValue();

    // Build the main object
    const finalObj = {
      id: this.edit ? this.editId : 0,
      blockId: Number(this.targetForm.getRawValue().blockOffice) || 0,
      financialYear: this.targetForm.getRawValue().financialYear || '',
      dataMonth: new Date().getMonth() + 1, // ✅ current month number
      tAuditConductedUptoDate: Number(formData.tAuditConductedUptoDate) || 0,

      // ✅ Build nested list according to API model
      auditList: [
        {
          auditType: 'Departmental Auditor',
          auditFeesAssessed: Number(formData.dAuditFeesAssessed) || 0,
          auditFeesRecovered: Number(formData.dAuditFeesRecovered) || 0,
          auditConducted: Number(formData.dtAuditConducted) || 0,
          auditFeesBalance: Number(formData.dAuditFeesBalance) || 0
        },
        {
          auditType: 'Certified Auditor',
          auditFeesAssessed: Number(formData.cAuditFeesAssessed) || 0,
          auditFeesRecovered: Number(formData.cAuditFeesRecovered) || 0,
          auditConducted: Number(formData.ctAuditConducted) || 0,
          auditFeesBalance: Number(formData.cAuditFeesBalance) || 0
        },
        {
          auditType: 'Chartered Accountant',
          auditFeesAssessed: Number(formData.caAuditFeesAssessed) || 0,
          auditFeesRecovered: Number(formData.caAuditFeesRecovered) || 0,
          auditConducted: Number(formData.catAuditConducted) || 0,
          auditFeesBalance: Number(formData.caAuditFeesBalance) || 0
        },
        {
          auditType: 'Retiree Auditor',
          auditFeesAssessed: Number(formData.rAuditFeesAssessed) || 0,
          auditFeesRecovered: Number(formData.rAuditFeesRecovered) || 0,
          auditConducted: Number(formData.rtAuditConducted) || 0,
          auditFeesBalance: Number(formData.rAuditFeesBalance) || 0
        }
      ]
    };


    this.reportService.addAuditFeesMPR(finalObj).subscribe(
      (res) => {
        if (res && res.status === 200) {
          this.hideModal('addAuditFeeMPRModal');
          this.auditFeeForm.reset();
          this.toastService.showSuccess(res.message);
          this.getAuditFeesMPR();
        }
      },
      (error) => {
        console.error('❌ API Error:', error);
      }
    );
  }

  editRow(row: any): void {
    const headerData: any = row;

    // Find each auditor data by AuditType
    const departmental = headerData.items.find((x: any) => x.auditorType === 'Departmental Auditor') || {};
    const certified = headerData.items.find((x: any) => x.auditorType === 'Certified Auditor') || {};
    const chartered = headerData.items.find((x: any) => x.auditorType === 'Chartered Accountant') || {};
    const retiree = headerData.items.find((x: any) => x.auditorType === 'Retiree Auditor') || {};

    // Patch form with correct values
    this.auditFeeForm.patchValue({
      tAuditConductedUptoDate: Number(headerData.tAuditConductedUptoDate),

      // Departmental Auditor
      dAuditFeesAssessed: Number(departmental.auditFeesAssessed) || 0,
      dAuditFeesRecovered: Number(departmental.auditFeesRecovered) || 0,
      dtAuditConducted: Number(departmental.totalAuditConducted) || 0,
      dAuditFeesBalance: Number(departmental.balanceAuditFees) || 0,

      // Certified Auditor
      cAuditFeesAssessed: Number(certified.auditFeesAssessed) || 0,
      cAuditFeesRecovered: Number(certified.auditFeesRecovered) || 0,
      ctAuditConducted: Number(certified.totalAuditConducted) || 0,
      cAuditFeesBalance: Number(certified.balanceAuditFees) || 0,

      // Chartered Accountant
      caAuditFeesAssessed: Number(chartered.auditFeesAssessed) || 0,
      caAuditFeesRecovered: Number(chartered.auditFeesRecovered) || 0,
      catAuditConducted: Number(chartered.totalAuditConducted) || 0,
      caAuditFeesBalance: Number(chartered.balanceAuditFees) || 0,

      // Retiree Auditor
      rAuditFeesAssessed: Number(retiree.auditFeesAssessed) || 0,
      rAuditFeesRecovered: Number(retiree.auditFeesRecovered) || 0,
      rtAuditConducted: Number(retiree.totalAuditConducted) || 0,
      rAuditFeesBalance: Number(retiree.balanceAuditFees) || 0
    });

    this.editId = headerData.id || 0;
    this.edit = true;

    this.openModal('addAuditFeeMPRModal');
  }


  getAuditFeesMPR() {
    const obj = {
      blockId: this.targetForm.getRawValue().blockOffice,
      financialYear: this.targetForm.value.financialYear,
    };

    this.reportService.getAuditFeesMPR(obj).subscribe(
      (res: any) => {
        if (res?.data?.length) {
          // ✅ Step 1: Transform API response
          this.auditData = res.data;


          this.tableData = this.auditData.map((item: any, index: number) => ({
            sno: index + 1,
            tAuditConductedUptoDate: item.tAuditConductedUptoDate,
            month: this.getMonthName(item.dataMonth),
            auditorType: item.auditType,
            blockID: item.blockID,
            dataMonth: item.dataMonth,
            isVerified: item.isVerified,
            financialYear: item.financialYear,
            auditFeesAssessed: item.auditFeesAssessed,
            auditFeesRecovered: item.auditFeesRecovered,
            totalAuditConducted: item.auditConducted,
            balanceAuditFees: item.auditFeesBalance
          }));

          // ✅ Step 2: Group data by month
          this.groupedTableData = this.groupByMonth(this.tableData);


          //this.showButton = true;
          const currentMonthExists = this.groupedTableData.some(
            (x: any) => x.dataMonth == this.currentMonth.key
          );

          if (currentMonthExists) {
            this.showButton = true;
          } else {
            this.showButton = false;
          }
        } else {
          this.auditData = [];
          this.tableData = [];
          this.groupedTableData = [];
          this.showButton = true;
          // this.toastService.showInfo('No Data Found!');
        }
      },
      (error: any) => {
        console.error(error);
        this.toastService.showError('Something went wrong while fetching data');
      }
    );
  }

  // blockID
  // dataMonth
  // financialYear


  groupByMonth(data: any[]): { sno: number; month: string; items: any[] }[] {
    const grouped: { sno: number; month: string; items: any[], tAuditConductedUptoDate: number, blockID: Number, dataMonth: Number, financialYear: string, isVerified: boolean }[] = [];
    let serial = 1;

    data.forEach((item: any) => {
      const existingGroup = grouped.find(g => g.month === item.month);
      if (existingGroup) {
        existingGroup.items.push(item);
      } else {
        grouped.push({
          sno: serial++, // ✅ serial number for each month
          month: item.month,
          blockID: item.blockID,
          dataMonth: item.dataMonth,
          financialYear: item.financialYear,
          isVerified: item.isVerified,
          tAuditConductedUptoDate: item.tAuditConductedUptoDate,
          items: [item]
        });
      }
    });

    return grouped;
  }





  // ✅ Convert month number to readable month name
  getMonthName(monthNumber: number): string {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months[monthNumber - 1] || '-';
  }



  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }


  // deleteAuditFeesMPR(id: any) {
  //   this.reportService.DeleteAuditConducted(id).subscribe((res: any) => {
  //     if (res) {

  //       if (res?.status == 200) {
  //         this.toastService.showSuccess(res.message);
  //         this.deleteIndex = 0;
  //         // this.hideModal();
  //         this.getAuditFeesMPR();
  //       }

  //     }
  //   },
  //     (error: any) => {
  //     }
  //   );
  // }
  closeModel() {
    this.auditFeeForm.reset()
    this.auditFeeForm.markAsUntouched()
    //   this.editId = 0
    // this.edit =false
  }

  // verifyAuditFeesMPR(id: any) {
  //   this.reportService.verifyaAuditConducted(id).subscribe((res: any) => {
  //     if (res) {

  //       if (res?.status == 200) {
  //         this.toastService.showSuccess(res.message);
  //         this.deleteIndex = 0;
  //         // this.hideModal();
  //         this.getAuditFeesMPR();
  //       }
  //     }
  //   },
  //     (error: any) => {
  //     }
  //   );
  // }
  deleteIndex: any
  setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  cancelDelete() {
    this.deleteIndex = 0;

  }

  addData() {
    this.auditFeeForm.patchValue({
      financialYear: this.targetForm.value?.financialYear,
      blockOffice: this.targetForm.getRawValue()?.blockOffice,
      dataMonth: this.currentMonth.key
    });
  }


  deleteRow: any

  deleteAuditFeesMPR(row: any) {


    let payload = {
      "blockId": row?.blockID,
      "financialYear": row?.financialYear,
      "dataMonth": row?.dataMonth
    }


    this.reportService.deleteAuditFeesMPR(payload).subscribe((res: any) => {

      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteRow = null;
          // this.hideModal();
          this.getAuditFeesMPR();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  verifyAuditFeesMPR(row: any) {
    let payload = {
      "blockId": row?.blockID,
      "financialYear": row?.financialYear,
      "dataMonth": row?.dataMonth
    }

    this.reportService.verifyAuditFeesMPR(payload).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);

          // this.hideModal();
          this.getAuditFeesMPR();
        }

      }
    },
      (error: any) => {
      }
    );
  }
}


